module.exports = __webpack_public_path__ + "static/mfg-asset_management-min.57bb32dd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/asset-management/mfg-asset_management-min.png
// module id = 489
// module chunks = 207213880550192